'use strict';

define('global/service/langService', ['lib/js-cookie-2.1.4/js.cookie'], function (Cookie) {

  'use strict';

  var localMap = {
    zh: 'CN',
    en: 'UK',
    es: 'ES',
    pt: 'PT'
    // 安全的执行异步任务
    // 超过最大执行时间时直接视为已执行完成
  };var waitCall = function waitCall(promise, timeout) {
    var isTimeout = false;
    var isDone = false;
    return $.Deferred(function (dtd) {
      setTimeout(function () {
        if (!isDone) {
          isTimeout = true;
          dtd.resolve();
          isDone = true;
        }
      }, timeout);

      promise.then(function () {
        if (!isTimeout) {
          dtd.resolve();
          isDone = true;
        }
      }, function () {
        if (!isTimeout) {
          dtd.resolve();
          isDone = true;
        }
      });
    }).promise();
  };

  var LangService = {
    asyncLan: function asyncLan(targetLang) {
      Cookie.set('pkHomeLang', targetLang, { path: '/', expires: 366, domain: 'pkfare.com' });
      Cookie.set('pkNewLang', localMap[targetLang], { path: '/', domain: 'pkfare.com', expires: 366 });
      Cookie.set('lang', localMap[targetLang], { path: '/', domain: 'pkfare.com', expires: 366 });
      Cookie.set('language', localMap[targetLang].toLowerCase(), { path: '/', domain: 'pkfare.com', expires: 366 });
    },
    init: function init() {
      this.asyncLan(this.getLang());
    },
    getLang: function getLang() {
      return Cookie.get('pkHomeLang') || 'en'; // 总是由中间层确保Cookie有值，极端情况下视为英文
    },
    updateLang: function updateLang(targetLang) {
      // 同步设置历史遗留的 pkHomeLang、pkNewLang、lang 三个语言标识
      // 特别地，使用lang的pkfareApp，对于非采购角色不支持中文页面，由站点自行检查
      this.asyncLan(targetLang);
      return waitCall($.post('/account/changeLanguage', { langType: localMap[targetLang] }), 5000);
    },
    checkPkfareLang: function checkPkfareLang(roleId) {
      // 对于非buyer或者是supplier用户，pfareApp不支持中文，强制切换为英文
      if ([3, 4, 5, 2, 6].indexOf(roleId) === -1) {
        Cookie.set('lang', 'UK', { path: '/', domain: 'pkfare.com', expires: 366 });
        Cookie.set('pkNewLang', 'UK', { path: '/', domain: 'pkfare.com', expires: 366 });
        Cookie.set('language', 'uk', { path: '/', domain: 'pkfare.com', expires: 366 });
        return waitCall($.post('/account/changeLanguage', { langType: 'UK' }), 5000);
      } else {
        Cookie.set('lang', localMap[this.getLang()], { path: '/', domain: 'pkfare.com', expires: 366 });
        Cookie.set('pkNewLang', localMap[this.getLang()], { path: '/', domain: 'pkfare.com', expires: 366 });
        Cookie.set('language', localMap[this.getLang()].toLowerCase(), { path: '/', domain: 'pkfare.com', expires: 366 });
        return waitCall($.post('/account/changeLanguage', { langType: localMap[this.getLang()] }), 5000);
      }
    }
  };

  return LangService;
});